import { Link } from 'react-scroll'

import Title from '../components/items/Title'
import LinkButton from '../components/items/LinkButton'

import profile from '../img/profile.png'

import styles from './start.module.css'

export default function Start() {
  return (
    <section id="Start" className={styles.containerHome}>
      <div className={styles.containerInfo}>
        <Title title="TRANSFORMANDO IDEIAS " subTitle="EM REALIDADE DIGITAL." />
        <h3>
          Criatividade e inovação andam lado a lado. Com uma combinação única de
          design impactante, funcionalidade intuitiva e otimização para
          resultados, estou pronto para criar a presença online dos seus sonhos.
        </h3>
        <div className={styles.containerBtn}>
          <Link
            activeClass="active"
            to="Contact"
            spy={true}
            smooth={true}
            offset={-50}
            duration={500}
          >
            <LinkButton text="Entre em contato" />
          </Link>
        </div>
      </div>
      <div className={styles.containerProfile}>
        <img src={profile} alt="Profile Eduardo Riccetto Dev" />
      </div>
    </section>
  )
}
